import axiosInstance from "../../../http-common";
import { v4 } from "uuid";
import { logout_if_403 } from "../../../util";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};
export const load_production_planner_data_from_backend = async (
  data,
  setData,
  tabName
) => {
  // console.log("loading po from backend");
  try {
    const result = await axiosInstance.get(
      `v1/qc/open_po_new/${tabName}/?user=production_team`
    );
    // console.log(result);
    if (result.data) {
      const tableData = result?.data?.data?.map((item) => ({
        ...item,
        id: v4(),
      }));
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {

    logout_if_403(error);
    console.error(getErrorMessage(error));
    // dispatch(po_load_failure_action(err));
  }
};

// to edit
export const edit_prod_planner_schedule = async ({
  batch_no,
  expected_delivery_date_by_production,
  material_type,
}) => {
  try {
    const body = {
      batch_no,
      expected_delivery_date_by_production,
    };
    const response = await axiosInstance.patch(
      `/v1/qc/open_po_new/${material_type}/`,
      body
    );
    const result = (await response).data;
    const { status, error } = result;
    if (status === "success") {
      return {
        status: true,
        message: "Data Updated Successfully",
      };
    }
    return {
      status: false,
      message: error,
    };
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  }
};

// to upload open po files
export const upload_open_po_file = async (uploaded_file, tabName) => {
  try {
    const data = new FormData();
    data.append("excel_file", uploaded_file);
    console.log([...data.entries()]);
    const response = await axiosInstance.post(
      `/v1/qc/upload_open_po/${tabName}/`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const result = response.data;
    // console.log({ result });
    if (result.status === "error") {
      throw new Error(result.message);
    } else if (result.status === "success") {
      return `Data uploaded successfully! Loading the new ${tabName} data now`;
    }
  } catch (error) {
    console.log({ error });
    throw new Error("An error occurred while uploading the file.");
  }
};
